import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import { Box, Alert, Heading, Text } from 'localmed-core';
import styled from '@emotion/styled';

import { ProviderSchedulingCalendarWithData } from '../../../../../shared/components/SchedulingCalendar';
import { FLASH_MESSAGES } from '../../../../../shared/constants';

import { getQueryFromLocation } from '../../../../../shared/utils/urls';

const Span = styled('span')`
  white-space: nowrap;
  font-weight: bold;
`;

function ProviderPageCalendar({
  provider,
  reasonsForVisit,
  onlineSchedulingEnabled,
  office,
  selectedPatientStatus,
  reasonForVisit,
  schedulingParams,
  history,
  ...containerProps
}) {
  const query = getQueryFromLocation(history.location);
  const hasNotAvailableMessage = query.message === FLASH_MESSAGES.OPENING_NOT_AVAILABLE;
  const appointmentCancelled = query.message === FLASH_MESSAGES.APPOINTMENT_CANCELED;

  const reasonForVisitItems = reasonsForVisit.filter(
    (r) => r.patientStatus === selectedPatientStatus.id
  );
  const noOnlineSchedulingForStatus = reasonForVisitItems.length === 0;
  const noOnlineScheduling = !onlineSchedulingEnabled;

  return (
    <Box {...containerProps}>
      {hasNotAvailableMessage && (
        <Alert tier="error" marginBottom="sm">
          We’re sorry, but the appointment you requested is no longer available. Please select from
          the available appointments.
        </Alert>
      )}
      {appointmentCancelled && (
        <Alert tier="success" marginBottom="sm">
          Your appointment has been successfully canceled.
        </Alert>
      )}
      {reasonsForVisit.length === 0 || noOnlineScheduling ? (
        <Alert tier="warning">
          <Heading tier="h3" fontWeight="bold" color="white">
            {provider.display} is not offering online scheduling.
          </Heading>
          <Text>
            Please call us at <Span>{office.phone}</Span> to schedule your appointment.
          </Text>
        </Alert>
      ) : (
        <Fragment>
          <ProviderSchedulingCalendarWithData
            providerId={provider.id}
            office={office}
            reasonForVisit={reasonForVisit}
            selectedDate={schedulingParams.values.selectedDate}
            minDate={schedulingParams.values.minDate}
            onChangeSelectedDate={schedulingParams.updateSelectedDate}
            withForm
            providerDisplay={provider.display}
            reasonForVisitItems={reasonForVisitItems}
            selectedPatientStatus={selectedPatientStatus}
            noOnlineSchedulingForStatus={noOnlineSchedulingForStatus}
            onChangePatientStatus={schedulingParams.updatePatientStatus}
            onChangeReasonForVisit={schedulingParams.updateReasonForVisit}
            p={{ _: 'md', lg: 0 }}
          />
        </Fragment>
      )}
    </Box>
  );
}

export default withRouter(ProviderPageCalendar);
